import useCopyToClipboard from "@/Hooks/useCopyToClipboard";

export const useShareArticle = (text, isMobile) => {
    const {copied, copyFn} = useCopyToClipboard();

    const share = async () => {
        const url = location.href;

        if (navigator.share && isMobile) {
            await navigator.share({title: '', text, url});
        } else {
            copyFn(url);
        }
    };

    return {share, copied};
};
